import { useEffect, useRef } from 'react';

import { AnalyticsEvent, track } from '@bonusly/analytics';

import { useBizySidePanelStore } from '../store/use-bizy-side-panel-store';

/**
 * Tracks Bizy side-panel open/close transitions in Amplitude.
 * Shared by useBizyLayout (user-facing) and useBizyAdminLayout (admin).
 */
export function useBizyPanelTracking(isPanelOpen: boolean) {
	const prevPanelOpenRef = useRef(isPanelOpen);
	useEffect(() => {
		if (prevPanelOpenRef.current === isPanelOpen) return;
		prevPanelOpenRef.current = isPanelOpen;

		const trigger = useBizySidePanelStore.getState().lastTrigger;

		if (isPanelOpen) {
			track(AnalyticsEvent.Bizy.ChatOpened, { path: window.location.pathname, trigger });
			track(AnalyticsEvent.Bizy.ChatSeen, { path: window.location.pathname, trigger });
		} else {
			track(AnalyticsEvent.Bizy.ChatClosed, { path: window.location.pathname, trigger });
		}
	}, [isPanelOpen]);
}
